import { Controller, useFormContext } from 'react-hook-form';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { Select, FormControl, FormHelperText } from '@mui/material';
import { FormError } from '../../../components/hook-form/hook-form-error';

export interface SelectFieldOption {
  value: any;
  label: string;
  isDefault?: boolean;
}

interface SelectFieldProps {
  options: SelectFieldOption[];
  label: string;
  name: string;
  selectInfo?: any;
  onChange?: any;
  disabled?: boolean;
  className?: string;
  required?: boolean; // Add required validation flag
}

export const FormSelect = ({
  name,
  label,
  options,
  selectInfo,
  onChange,
  disabled,
  className,
  required,
}: SelectFieldProps): any => {
  const { control } = useFormContext();

  const handleChange = (value: any) => {
    onChange(value);
  };

  return (
    <div>
      <div className="select">
        <Controller
          control={control}
          name={name}
          rules={{
            required: required ? `${label} is required` : false, // Apply required validation if `required` is true
          }}
          render={({ field, fieldState }) => (
            <FormControl
              fullWidth
              disabled={disabled}
              error={!!fieldState.error} // Show error styling if validation fails
            >
              <InputLabel size="small" id={`${name}-select-label`}>
                {label}
              </InputLabel>
              <Select
                size="small"
                labelId={`${name}-select-label`}
                id={`${name}-select`}
                label={label}
                value={field.value || ''}
                onChange={(e) => {
                  field.onChange(e);
                  handleChange(e.target.value);
                }}
                className={`${className} ${required ? 'itsarequiredField' : ''} ${field.value ? 'has-data' : ''}`} // Check if field.value exists
              >
                {options?.map((o) => (
                  <MenuItem key={`${name}-${o.value}`} value={o.value}>
                    {o.label}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText style={{ marginLeft: 1 }}>{fieldState.error?.message || selectInfo}</FormHelperText>
            </FormControl>
          )}
        />
        {/* <FormError name={name} /> */}
      </div>
    </div>
  );
};

FormSelect.defaultProps = {
  onChange: () => {
    return;
  },
};
